export const isArrayEqual = (firstArray: string[], secondArray: string[]) =>
  secondArray.find((item: string) => !firstArray.includes(item)) === undefined &&
  firstArray.find((item: string) => !secondArray.includes(item)) === undefined;
